export default "/images/a86bccca40fe52ac97dacd4464d72ae0.jpg";